<template>
  <b-col lg="12">

    <router-link v-if="mode!='create'" :to="{name:'SingleCategory',params:{slug:category.slug}}">
       <span class="badge badge-primary p-2 rounded-pill">محصولات دسته: {{
           category.products_count
         }}</span>
    </router-link>


    <b-form @submit.prevent="onSubmit" class="mt-4  p-1">

      <b-form-row>
        <b-col lg="4">
          <form-group :validations="$v.form.name">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="نام دسته"
                  class="mb-4"
              >
                <b-form-input
                    v-model="form.name"
                    type="text"
                    placeholder="نام دسته"
                    :class="{ invalid }"
                    class="rounded-pill"
                ></b-form-input>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>

        <b-col lg="4">
          <form-group :validations="$v.form.slug">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="slug"
                  class="mb-4"
              >
                <b-form-input
                    v-model="form.slug"
                    type="text"
                    placeholder="slug"
                    :class="{ invalid }"
                    class="rounded-pill"
                ></b-form-input>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
        <b-col lg="4">
          <form-group :validations="$v.form.parent_id">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="زیر دسته"
                  class="mb-4"
              >
                <select class="form-control rounded-pill" v-model="form.parent_id">
                  <option value="null" class="text-dark">بدون زیردسته</option>
                  <option v-for="category in flatCategories(categories)" :value="category.id" class="text-dark">
                    {{ category.name }}
                  </option>
                </select>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>
      </b-form-row>

      <b-form-row>

        <b-col lg="6">
          <form-group :validations="$v.form.description">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  label="توضیحات"
                  class="mb-4"
              >
                <b-form-textarea
                    v-model="form.description"
                    placeholder="توضیحات"

                ></b-form-textarea>
                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>

        <b-col lg="6" class="text-center">
          <form-group :validations="$v.form.image">
            <div slot-scope="{ errors, invalid }">
              <b-form-group
                  class="mt-4">

                <b-row>

                  <b-col lg="6" md="6" v-if="mode==='create'">
                    <label class="btn btn-warning d-block rounded-pill text-white btn-sm"
                           :for="`choose_category_image_create`">انتخاب عکس</label>
                    <b-form-file
                        :id="`choose_category_image_create`"
                        browse-text="انتخاب عکس"
                        @change="onFileChange"
                        class="text-center mt-2 mr-2 d-none"
                        v-model="form.image"
                        placeholder="انتخاب عکس"
                    ></b-form-file>
                    <input type="hidden" @change="onFileChange"/>
                  </b-col>

                  <b-col lg="6" md="6" v-else>
                    <label class="btn btn-warning d-block rounded-pill text-white btn-sm"
                           :for="`choose_category_image_${category.id}`">انتخاب عکس</label>
                    <label v-if="form.preview!=null"
                           @click="removeImage(category)"
                           class="btn btn-danger d-block rounded-pill text-white btn-sm">حذف عکس</label>
                    <b-form-file
                        :id="`choose_category_image_${category.id}`"
                        browse-text="انتخاب عکس"
                        @change="onFileChange"
                        class="text-center mt-2 mr-2 d-none"
                        v-model="form.image"
                        placeholder="انتخاب عکس"
                    ></b-form-file>
                    <input type="hidden" @change="onFileChange"/>
                  </b-col>

                  <b-col lg="6" md="6">
                    <div class="">
                      <img alt="" class="rounded w-100" v-if="form.preview" width="150" height="auto"
                           :src="form.preview"/>
                    </div>
                  </b-col>
                </b-row>

                <form-errors-manager :errors="errors"/>
              </b-form-group>
            </div>
          </form-group>
        </b-col>

      </b-form-row>

      <b-col lg="12" v-if=" mode==='trash'">
        <b-button pill type="submit" @click="restoreCategory(category)" class="mr-1 mb-1  d-inline-block col-lg-2"
                  variant="success">
          بازیابی
        </b-button>

        <b-button pill @click="forceDelete(category)" class=" mr-1 mb-1 d-inline-block col-lg-2" variant="danger">
          حذف
        </b-button>
      </b-col>

      <b-col lg="12" v-if=" mode==='create'">
        <b-button pill type="submit" class="mr-1 mb-1  d-inline-block col-lg-2"
                  variant="success">
          تایید
        </b-button>

      </b-col>

      <b-col lg="12" v-if="mode==='categories'">
        <b-button pill type="submit" class="mr-1 mb-1  d-inline-block col-lg-2" variant="success">
          تایید
        </b-button>

        <b-button pill @click="deleteCategory(category)" class=" mr-1 mb-1 d-inline-block col-lg-2" variant="danger">
          حذف
        </b-button>
      </b-col>
    </b-form>

  </b-col>
</template>

<script>
import {mapGetters} from 'vuex'
import {slug} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins'
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager
  from "../../validator/FormErrorsManager.vue";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";

export default {
  name: "Category",
  components: {FormErrorsManager, FormGroup},
  data() {
    return {
      form: {
        id: "",
        name: "",
        description: "",
        image: [],
        parent_id: '',
        slug: '',
        preview: ''
      },
    };
  },
  computed: {
    ...mapGetters({
      categories: "Category/getFilteredCategories"
    }),

  },
  validations: {
    form: {
      name: {required},
      description: {},
      image: {},
      slug: {required, slug},
      parent_id: {}
    },
  },
  props: {
    category: {},
    submitMethod: {},
    mode: {
      default: 'categories'
    }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.preview = URL.createObjectURL(file);
    },
    async removeImage(category) {
      await this.$store.dispatch('Category/removeCategoryImage', category).then(async () => {
        this.form.preview = null
      })
    },
    flatCategories,
    deleteCategory(category) {
      if (confirm("آیا از حذف دسته بندی اطمینان دارید؟")) {
        this.$store.dispatch("Category/deleteCategory", category);
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.mode === 'create') {
          this.$store.dispatch("Category/createCategory", this.form);
        }
        if (this.mode === 'categories') {
          this.$store.dispatch("Category/updateCategory", this.form)
        }
      }
    },
    restoreCategory(category) {
      this.$store.dispatch("Category/restoreCategory", category);
    },
    forceDelete(category) {
      if (confirm("آیا از حذف دائمی اطمینان دارید؟")) {
        this.$store.dispatch("Category/forceDelete", category);
      }
    },
  },
  mounted() {

    if (this.mode !== 'create') {
      this.form.id = this.category.id
      this.form.name = this.category.name
      this.form.description = this.category.description
      this.form.preview = this.category.image
      this.form.parent_id = this.category.parent_id
      this.form.slug = this.category.slug
    } else {
      this.form.parent_id = null
    }

  }
}
</script>

<style scoped>

</style>